var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3335 3.33329C3.3335 2.41282 4.07969 1.66663 5.00016 1.66663H11.6668C11.8878 1.66663 12.0998 1.75442 12.2561 1.9107L16.4228 6.07737C16.579 6.23365 16.6668 6.44561 16.6668 6.66663V16.6666C16.6668 17.5871 15.9206 18.3333 15.0002 18.3333H5.00016C4.07969 18.3333 3.3335 17.5871 3.3335 16.6666V3.33329ZM11.3217 3.33329L5.00016 3.33329V16.6666H15.0002V7.0118L11.3217 3.33329Z",
    fill: "#1E293B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8335 1.66663C11.2937 1.66663 11.6668 2.03972 11.6668 2.49996V6.66663H15.8335C16.2937 6.66663 16.6668 7.03972 16.6668 7.49996C16.6668 7.9602 16.2937 8.33329 15.8335 8.33329H10.8335C10.3733 8.33329 10.0002 7.9602 10.0002 7.49996V2.49996C10.0002 2.03972 10.3733 1.66663 10.8335 1.66663Z",
    fill: "#1E293B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.d4f1ecf9ea6efda3e71b8793e3ab0de9.svg";
export { ForwardRef as ReactComponent };